module.exports = __webpack_public_path__ + "media/images/lp_PC_2_2-a030b978e502167f434fa6dcd3ea3f06.webp";